import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

async function fetchTags(): Promise<string[]> {
  const { data } = await client.get<string[]>('glm-kilo-flows/tags/');
  return data;
}

export default function useTags(): ReturnType<typeof useQuery> {
  return useQuery({
    queryKey: ['tags'],
    queryFn: fetchTags,
  });
}
